// extracted by mini-css-extract-plugin
export default {"root":"vsejaj","bg":"T6TiIN"};